import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";

export class Timeline {

  constructor(el) {
    this.$el = $(el);
    this.tl = null;

    this.officialHighlightIndex = -1;
    this.restoreOfficialHighlight = null

    const docStyle = getComputedStyle(document.documentElement);
    this.highlightColor = docStyle.getPropertyValue("--timelineHighlight");

    this.$el.find(".item-trigger").on("click", (e) => {
      this.itemClick($(e.currentTarget).parents(".timeline-item"))
    });

    this.reset();
  }

  itemClick(item) {
    const itemIndex = item.index() - 1;
    this.highlight(itemIndex, false)
    this.restoreOfficialHighlight = setTimeout(() => this.highlight(this.officialHighlightIndex), 5000);
  }

  highlight(index, officialHighlight = true) {

    if (officialHighlight) this.officialHighlightIndex = index;
    this.clearRestoreTimeout();

    if (this.tl) {
      this.tl.kill()
      this.tl = null;
    }

    this.tl = gsap.timeline({});

    this.$el.find(".timeline-item").each((i, n) => {
      const label = $(".timeline-item-label", n);
      const isActive = (i === index);
      const svgId = (index !== null) ? $(n).data("svg-id") : null;
      const $svgGroup = this.$el.find(`.svg-wrapper #${svgId}`)
      const $pathEl = $svgGroup.find("path, rect", $svgGroup);
      const $strokeEl = $svgGroup.find("circle, svg ellipse", $svgGroup);

      if (!isActive) {
        // Inactive element
        if (label.length > 0) this.tl.to($(".timeline-item-label", n), {autoAlpha: 0, y: 10}, 0);
        if (officialHighlight) {
          if ($pathEl.length > 0) this.tl.to($pathEl, {fill: "#FFFFFF", stroke: "#FFFFFF"}, 0);
          if ($strokeEl.length > 0) this.tl.to($strokeEl, {stroke: "#FFFFFF"}, 0);
        }

      } else {
        // Active element
        if (label.length > 0) this.tl.to($(".timeline-item-label", n), {autoAlpha: 1, y: 0}, 0.5);
        if (officialHighlight) {
          if ($pathEl.length > 0) this.tl.to($pathEl, {fill: this.highlightColor, stroke: this.highlightColor}, 0.5);
          if ($strokeEl.length > 0) this.tl.to($strokeEl, {stroke: this.highlightColor}, 0.5);
        }
      }
    })

    return this;
  }

  hide(reset = false) {
    const tl = gsap.timeline()
    tl.to(this.$el, {autoAlpha: 0});
    if (reset) tl.add(() => this.reset())
    return this;
  }

  show() {
    gsap.to(this.$el, {autoAlpha: 1});
    return this;
  }

  clearRestoreTimeout() {
    if (this.restoreOfficialHighlight !== null) {
      clearTimeout(this.restoreOfficialHighlight);
      this.restoreOfficialHighlight = null;
    }
  }

  reset() {
    this.officialHighlightIndex = -1;
    this.clearRestoreTimeout();

    this.$el.find(".timeline-item").each((i, n) => {
      const label = $(".timeline-item-label", n);
      if (label.length > 0) {
        gsap.set(label, {autoAlpha: 0, y: 10});
        this.highlight(null)
      }
    })
    return this;
  }

}

